import { render, staticRenderFns } from "./outEntrepotDetail.vue?vue&type=template&id=9b267616&scoped=true&"
import script from "./outEntrepotDetail.vue?vue&type=script&lang=js&"
export * from "./outEntrepotDetail.vue?vue&type=script&lang=js&"
import style0 from "./outEntrepotDetail.vue?vue&type=style&index=0&id=9b267616&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9b267616",
  null
  
)

export default component.exports